<template>
    <div class="flex justify-between">
        <div>
            <div @click="SET_SHOW_SIDE_NAV(!getshowSideNav)"
                class="h-[4.2em]  flex items-center flex-shrink-0 px-3 py-2 cursor-pointer" title="Expandir">
                <div class="w-full h-9 bg-blue-600 rounded-lg flex items-center justify-center">
                    <svg :class="{ '-rotate-180': getshowSideNav }"
                        class="w-6 h-6 text-white transition ease-in-out delay-150 duration-300"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" />
                    </svg>
                </div>
            </div>
            <div class="flex-1 overflow-hidden hover:overflow-y-auto border-gray-100">
                <div class="px-2">
                    <ul class="space-y-1 pt-4 text-sm">
                        <li v-for="item in getFilteredItensNavBar" :key="item.key" :class="'group/principal-' + item.key"
                            :title="item.name">
                            <details v-if="item.sublinks.length" @click="SET_SHOW_SIDE_NAV(true)"
                                class="group [&_summary::-webkit-details-marker]:hidden">
                                <!-- Caso tenha sublinks -->
                                <summary :class="{ 'bg-gray-200 cursor-default': activeNavItem(item) }"
                                    class="flex cursor-pointer items-center justify-between rounded-lg pl-3 py-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700">
                                    <div class="flex items-center text-sm font-medium space-x-2">
                                        <div v-html="item.svg"></div>
                                        <div :class="{ 'lg:hidden': !getshowSideNav }">{{ item.name }}</div>
                                    </div>
                                    <span :class="{ 'lg:hidden': !getshowSideNav }"
                                        class="mr-2 shrink-0 transition duration-300 group-open:-rotate-180">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20"
                                            fill="currentColor">
                                            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 
                                    111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                        </svg>
                                    </span>
                                </summary>

                                <ul v-if="getshowSideNav" class="mt-2 space-y-1 px-2">
                                    <li v-for="sublink in item.sublinks" :key="sublink.id">
                                        <router-link :to="sublink.url"
                                            class="block rounded-lg pl-8 py-2 text-sm text-left font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700">
                                            {{ sublink.name }}
                                        </router-link>
                                    </li>
                                </ul>
                            </details>

                            <div v-else>
                                <!-- Caso NÃO tenha sublinks, substitui o summary pelo router-link -->
                                <router-link :to="item.url"
                                    :class="{ 'bg-gray-200 cursor-default': activeNavItem(item) }"
                                    class="flex items-center justify-between rounded-lg pl-3 py-2 text-sm font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700">
                                    <div class="flex items-center space-x-2">
                                        <div v-html="item.svg"></div>
                                        <div :class="{ 'lg:hidden': !getshowSideNav }">{{ item.name }}</div>
                                    </div>
                                </router-link>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="sticky inset-x-0 bottom-0 border-t border-gray-100 bg-white p-2">
            <button @click="LOG_USER_OUT()" type="button"
                class="group relative flex w-full justify-center rounded-lg border px-2 py-1.5 text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-700">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 opacity-75" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                <span :class="{ 'lg:hidden': !getshowSideNav }" class="ml-3"> Sair </span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: "SideNavComponnent",
    components: {},
    data() {
        return {
        }
    },
    methods: {
        ...mapMutations(['SET_SHOW_SIDE_NAV', 'LOG_USER_OUT']),

        activeNavItem(item) {
            return this.$route.path === item.url;
        }
    },
    computed: {
        ...mapGetters(['getshowSideNav', 'getItensNavBar', 'getFilteredItensNavBar']),
    }
}
</script>
<style scoped>
button {
    background: transparent;
}
</style>